import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { WhoDrugRecodeBinding } from "../hooks/useWhoDrugRecode";

export function WhoDrugAgentAction({ coding: c }: { coding: WhoDrugRecodeBinding }) {
  return <div className="cr-whodrug-agent-action flex flex-wrap items-center justify-between gap-2">
    <p className="text-xs text-muted-foreground">Keep your comparison open while TheraGenie checks the dictionary.</p>
    <Button size="sm" variant="outline" className="cr-whodrug-genie-trigger"
      disabled={!c.genie.canAsk} title={c.genie.disabledReason} onClick={c.genie.ask}>
      <Sparkles className="h-4 w-4" aria-hidden="true" />Ask TheraGenie
    </Button>
  </div>;
}
